import { Component } from '@angular/core';
import { Datalistviewcolumn } from 'src/app/shared/datalistview/columns/datalistviewcolumn';

@Component({
  selector: 'app-valetkeyaudits',
  templateUrl: './valetkeyaudits.component.html',
  styleUrls: ['./valetkeyaudits.component.scss'],
  standalone: false
})
export class ValetKeyAuditsComponent {
  constructor() { }

  public Columns: Array<Datalistviewcolumn> = [
    new Datalistviewcolumn("Date", "AuditedAtLocalFriendlyString"),
    new Datalistviewcolumn("Station", "ValetStationName"),
    new Datalistviewcolumn("Audited By", "AuditedByUserName"),
    new Datalistviewcolumn("With Key", "SessionsWithKeyCount"),
    new Datalistviewcolumn("Without Key", "SessionsWithoutKeyCount"),
    new Datalistviewcolumn("Keys w/o Session", "KeysWithoutSessionCount")
  ];
}
